module.exports = __webpack_public_path__ + "static/media/edit_icon.a7ee61b0.svg";